export default {
  sameAddress: {
    id: 'checkout_step_addresses_same_address_checkbox',
    defaultMessage: 'Same shipping and billing address',
  },
}
